import { createContext, useContext, useState } from "react";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { postLandingPagePayment } from "../../../../../../services/LandingPages/postLandingPagePayment";
//context
const TemplateContext = createContext();

export function TemplateProvider({ children }) {
  // states
  const form = useForm();
  const navigate = useNavigate();
  const { state } = useLocation();
  const { id } = useParams();
  const [cards, setCards] = useState([]);
  const [payment, setPayment] = useState(null);
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [contract, setContract] = useState(null);
  const [pixDataQR, setPixDataQR] = useState(null);
  const [pixClient, setPixClient] = useState(null);
  const [errorCupom, setErrorCupom] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [baseDataForm, setBaseDataForm] = useState(null);
  const [paymentMethod, setPaymentMethod] = useState(null);
  const [loadingButton, setLoadingButton] = useState(false);
  const [activeIndexModal, setActiveIndexModal] = useState(0);
  const [creditCardClient, setCreditCardClient] = useState(null);
  const [visiblePixPayment, setVisiblePixPayment] = useState(false);
  const [optionsInstallments, setOptionsInstallments] = useState([]);
  const [visiblePaymentMethods, setVisiblePaymentMethods] = useState(true);
  const [visibleModalCreditCard, setVisibleModalCreditCard] = useState(false);
  const [cardState, setCardState] = useState({
    card_number: "",
    expiry: "",
    cvc: "",
    name: "",
    focus: "",
  });

  // const handleInputChange = (name, value) => {
  //   setCardState((prev) => ({ ...prev, [name]: value }));
  // };

  const handleInputChange = (name, value) => {
    if (name === "expiry") {
      const [month, day] = value.split("/");
      if (
        month &&
        (parseInt(month, 10) > 12 ||
          (month !== "0_" && parseInt(month, 10) < 1))
      ) {
        setCardState((prevState) => ({
          ...prevState,
          expiry: "__/__",
        }));
        return;
      } else {
        setCardState((prev) => ({ ...prev, [name]: value }));
      }
    } else {
      setCardState((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleInputFocus = (name) => {
    setCardState((prev) => ({ ...prev, focus: name }));
  };

  const isFormIncomplete = (formData) => {
    return Object.values(formData).some(
      (value) => value === null || value === ""
    );
  };

  const handleSubmitPayment = async (landing_id, cupom) => {
    if (
      !paymentMethod === "pix" &&
      form.getValues("installments") === undefined
    ) {
      toast.warning("Selecione o número de prestações");
      return;
    }
    setLoadingButton(true);

    // console.log(cards);
    // console.log(itemsSelected);
    // console.log(cardState);
    // console.log(pixClient);
    // console.log(baseDataForm);
    // console.log(creditCardClient);
    // console.log(form.getValues());
    let obj = {
      landing_page_template_id: landing_id,
      enterprise_id: parseInt(id) || null,
      url: "teste.com",
    };
    console.log(obj);

    if (paymentMethod === "card") {
      const [exp_month, exp_year] = cardState.expiry.split("/");
      obj.payment = {
        payment_method: "card",
        holder_name: cardState.name,
        card_number: cardState.card_number,
        exp_month: exp_month,
        exp_year: exp_year,
        cvv: cardState.cvc,
        billing_address: {
          ...creditCardClient.address,
        },
        cupom: cupom || undefined,
      };
    }

    if (paymentMethod === "pix") {
      obj.payment = {
        payment_method: "pix",
        cupom: cupom || undefined,
      };
      setVisiblePixPayment(true);
    }

    if (cards.some((card) => card.active === 1)) {
      obj.payment = {
        payment_method: "card",
        cupom: cupom || undefined,
      };
      const card = cards.find((card) => card.active === 1);
      obj.payment.card_id = card.id;
    }

    console.log(obj);

    try {
      const response = await postLandingPagePayment(obj);
      console.log(response);
      if (response.status) {
        if (response.status === "400") {
          toast.danger("Número do cartão inválido!");
        } else {
          toast.danger("Erro no pagamento!");
        }
        setLoadingButton(false);
        return;
      }
      if (
        response.data?.link_QRcode &&
        response.data?.pix &&
        response.payment?.api_payment_id
      ) {
        setPixDataQR({
          id: response.payment.id,
          copy: response.data.pix,
          qr_code: response.data.link_QRcode,
          timer: 7,
        });
        setVisiblePixPayment(true);
        setLoadingButton(false);
        return;
      }

      if (response.success.payment_id) {
        toast.success(
          response.success.message ?? "Pagamento efetuado com sucesso!"
        );
        setVisible(false);
        navigate("/userRegistration", { state: { index: 1 } });
      }
      if (response.error) {
        toast.danger("Erro no pagamento!");
      }

      toast.success("Pagamento efetuado com sucesso!");
      setVisible(false);
    } catch (error) {
      console.log(error);
    }
    setLoadingButton(false);
  };

  return (
    <TemplateContext.Provider
      value={{
        form,
        cards,
        payment,
        visible,
        loading,
        contract,
        setCards,
        pixClient,
        cardState,
        pixDataQR,
        errorCupom,
        setLoading,
        setPayment,
        setVisible,
        setContract,
        activeIndex,
        setPixClient,
        handleSubmitPayment,
        setCardState,
        baseDataForm,
        setPixDataQR,
        loadingButton,
        paymentMethod,
        setErrorCupom,
        setActiveIndex,
        setBaseDataForm,
        activeIndexModal,
        isFormIncomplete,
        creditCardClient,
        handleInputFocus,
        setPaymentMethod,
        visiblePixPayment,
        handleInputChange,
        setActiveIndexModal,
        optionsInstallments,
        setCreditCardClient,
        setVisiblePixPayment,
        visiblePaymentMethods,
        setOptionsInstallments,
        visibleModalCreditCard,
        setVisiblePaymentMethods,
        setVisibleModalCreditCard,
      }}
    >
      {children}
    </TemplateContext.Provider>
  );
}

export function useTemplateContext() {
  return useContext(TemplateContext);
}
